import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="section-padding bg-background-50">
      <div className="container-custom">
        <div className="max-w-3xl mx-auto text-center py-12 md:py-16 px-6 md:px-12 rounded-2xl gold-gradient-bg border border-primary-200/30">
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 mb-4">
            开启您的精英国际化之旅
          </h2>
          <p className="text-sm md:text-base text-foreground-700 max-w-xl mx-auto leading-relaxed mb-8">
            豪门国际为您打开通往全球顶级资源的大门。无论您是在寻找商业伙伴、投资机会，还是渴望拓展精英社交圈层，我们都将是您最值得信赖的选择。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/about"
              className="px-8 py-3.5 text-sm font-medium whitespace-nowrap rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-all duration-300 cursor-pointer"
            >
              立即了解豪门国际
            </Link>
            <Link
              to="/category/resources"
              className="px-8 py-3.5 text-sm font-medium whitespace-nowrap rounded-full border border-primary-400 text-primary-700 hover:bg-primary-50 transition-all duration-300 cursor-pointer"
            >
              探索更多资源
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}